/**
 * Hero with Side Banners – Init Splide por sección
 * - Lee opciones desde data-* (autoplay, interval, pauseHover/Focus, arrows/dots).
 * - matchMedia para mobile (<=768px) y re-montaje solo cuando cambia el breakpoint.
 * - Reanuda autoplay al montar, al terminar interacciones y al volver de otra pestaña.
 */

(function () {
  const BP_QUERY = '(max-width: 768px)'; // Debe reflejar tu CSS
  const FALLBACK_INTERVAL = 4500;

  const instances = new WeakMap(); // Map<HTMLElement, { splide, mq, onChange, onVis }>

  const getBool = (val) => String(val) === 'true';

  function getOptions(el, isMobile) {
    const interval = Number(el.dataset.interval) || FALLBACK_INTERVAL;

    return {
      type: 'loop',
      autoplay: getBool(el.dataset.autoplay),
      interval,
      pauseOnHover: getBool(el.dataset.pauseHover), // desde schema
      pauseOnFocus: getBool(el.dataset.pauseFocus), // desde schema
      arrows: isMobile
        ? getBool(el.dataset.arrowsMobile)
        : getBool(el.dataset.arrowsDesktop),
      pagination: isMobile
        ? getBool(el.dataset.dotsMobile)
        : getBool(el.dataset.dotsDesktop),
      keyboard: 'global',
      updateOnMove: true,
      classes: {
        arrows: 'splide__arrows',
        arrow:  'splide__arrow',
        prev:   'splide__arrow--prev',
        next:   'splide__arrow--next',
      },
    };
  }

  function forcePlay(splide) {
    try {
      const AP = splide.Components.Autoplay;
      if (AP) AP.play();
    } catch (_) {}
  }

  function mount(el, isMobile) {
    const splide = new Splide(el, getOptions(el, isMobile));
    splide.on('mounted', () => forcePlay(splide));
    splide.on('move',    () => forcePlay(splide));
    splide.on('drag',    () => forcePlay(splide));
    splide.on('active',  () => forcePlay(splide));
    splide.mount();
    return splide;
  }

  function initOne(splideEl) {
    if (instances.has(splideEl)) return;

    const mq = window.matchMedia(BP_QUERY);
    let isMobile = mq.matches;
    let splide = mount(splideEl, isMobile);

    const onChange = (e) => {
      const nextIsMobile = e.matches;
      if (nextIsMobile === isMobile) return;
      isMobile = nextIsMobile;
      try { splide.destroy(); } catch (_) {}
      splide = mount(splideEl, isMobile);
    };

    const onVis = () => {
      if (!document.hidden) forcePlay(splide);
    };

    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
    document.addEventListener('visibilitychange', onVis);

    instances.set(splideEl, { splide, mq, onChange, onVis });
  }

  function destroyOne(splideEl) {
    const ref = instances.get(splideEl);
    if (!ref) return;
    try {
      ref.splide.destroy();
      if (ref.mq.removeEventListener) ref.mq.removeEventListener('change', ref.onChange);
      else ref.mq.removeListener(ref.onChange);
      document.removeEventListener('visibilitychange', ref.onVis);
    } catch (_) {}
    instances.delete(splideEl);
  }

  function initAll(root = document) {
    root.querySelectorAll('.hero-slider.splide').forEach(initOne);
  }

  function destroyAll(root = document) {
    root.querySelectorAll('.hero-slider.splide').forEach(destroyOne);
  }

  function ready(fn) {
    if (typeof Splide !== 'undefined') return fn();
    window.addEventListener('load', () => { if (typeof Splide !== 'undefined') fn(); });
  }

  document.addEventListener('DOMContentLoaded', () => { ready(() => initAll()); });
  document.addEventListener('shopify:section:load',  (e) => { ready(() => initAll(e.target)); });
  document.addEventListener('shopify:section:unload',(e) => { destroyAll(e.target); });
})();
